import { createFileRoute } from '@tanstack/react-router';
import ArmsRace from '../../components/ArmsRace';

export const Route = createFileRoute('/events/arms-race')({
  component: () => <ArmsRace />,
});







